"use client";

import { ChipLinks } from "@/components/common/chip-links";
import { Section } from "@/components/section";
import { useParams } from "next/navigation";

type CityLocationLinksProps = {
  data?: {
    seoHeading?: string;
    heading: string;
    cityLocationLinks: {
      title: string;
      slug: string;
    }[];
  };
  section: PageSections;
};

const CityLocationLinks = ({ data, section }: CityLocationLinksProps) => {
  const { country, city } = useParams<{ country: string; city: string }>();
  if (!country) return null;
  if (city || data?.cityLocationLinks?.length === 0) return null;
  return (
    <Section
      id={section.sectionId}
      className={section.sectionClass}
      title={data?.heading}
      seoTitle={data?.seoHeading}
    >
      <ChipLinks data={data?.cityLocationLinks} />
    </Section>
  );
};

export default CityLocationLinks;
